import {Component, OnInit, Input} from '@angular/core';
import {ErrorCode} from "../enums/error-codes";

@Component({
    selector: 'server-error',
    templateUrl: './server-error.component.html',
    styleUrls: ['./server-error.component.css']
})
export class ServerErrorComponent implements OnInit {
    @Input() errorCode=0;
    errorCodesEnum = ErrorCode;

    constructor() {}

    ngOnInit() {
    }
}



// WEBPACK FOOTER //
// ./src/app/server-error/server-error.component.ts